<app-spinner [blockedPanel]="blockedPanel"></app-spinner>
<div class="formModal assetModal" style="z-index: 105001 !important">
  <button class="d-flex justify-content-center" mat-raised-button color="warn" (click)="hideAssetModal()" style="width: 20px; min-width: 20px; height: 36px; float: right">&#10005;</button>
  <form [formGroup]="mediaForm">
    <mat-stepper #stepper>
      <mat-step *ngIf="showMediaStep">
        <ng-template matStepLabel>{{ "Media" | translate }}</ng-template>
        <div class="row mt-5">
          <div class="col-4 mt-0 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <input class="form-control modal-text-box" type="text" formControlName="umid" [attr.required]="true" />
                <label class="label-control">{{ "Unique Media ID" | translate }}</label>
                <div *ngIf="mediaForm.get('umid')?.touched && mediaForm.get('umid')?.invalid" class="text-danger font-12 mt-1">
                  <span *ngIf="mediaForm.get('umid')?.errors?.pattern">
                    {{ "UMID must follow the pattern: UMID followed by 4 digits (e.g., UMID1234)." | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="title" [attr.required]="true" />
                <label class="label-control">{{ "Media Title" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="type" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Type" | translate }} --</option>
                  <option *ngFor="let mediaType of dropdownMediaData?.mediaTypeList | sortAlpha : 'name'" value="{{ mediaType.id }}">{{ mediaType.name | translate }}</option>
                </select>
                <label class="label-control">{{ "Type Of Media" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="support" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Support" | translate }} --</option>
                  <option *ngFor="let mediaSupport of dropdownMediaData?.mediaSupportList | sortAlpha : 'name'" value="{{ mediaSupport.id }}">{{ mediaSupport.name | translate }}</option>
                </select>
                <label class="label-control">{{ "Support" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="format" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Format" | translate }} --</option>
                  <option *ngFor="let format of dropdownMediaData?.formats" value="{{ format.id }}">
                    {{ format.name | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Format" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="bitrate" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Bit Rate" | translate }} --</option>
                  <option *ngFor="let mediaBitrate of dropdownMediaData?.mediaBitrateList | sortAlpha : 'name'" value="{{ mediaBitrate.id }}">{{ mediaBitrate.name | translate }}</option>
                </select>
                <label class="label-control">{{ "Bit Rate" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="status" [attr.required]="true">
                  <option value="Ingested">{{ "Ingested" | translate }}</option>
                  <option value="Not Available">{{ "Not Available" | translate }}</option>
                </select>
                <label class="label-control">{{ "Status" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="sanstatus" [attr.required]="true">
                  <option value="Ready">{{ "Ready" | translate }}</option>
                  <option value="Not Available">{{ "Not Available" | translate }}</option>
                </select>
                <label class="label-control">{{ "SAN Status" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="language" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Language" | translate }} --</option>
                  <option *ngFor="let language of dropdownMediaData?.languages" value="{{ language }}">
                    {{ language | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Language" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="version" [attr.required]="true" />
                <label class="label-control">{{ "Version" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="person" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Checked By" | translate }} --</option>
                  <option *ngFor="let person of dropdownMediaData?.staffMemberList | sortAlpha : 'fullName'" value="{{ person.id }}">{{ person.fullName | translate }}</option>
                </select>
                <label class="label-control">{{ "Checked By" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-4">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" textMask]="{mask: mask}" formControlName="duration" [attr.required]="true" />
                <label class="label-control">{{ "Duration" | translate }}</label>
              </div>
            </div>
          </div>
        </div>

        <div>
          <button class="delete-btn-lt" *ngIf="hideDelete" (click)="deleteMedia()"><i class="fas fa-trash-alt"></i>{{ "Delete" | translate }}</button>
          <button class="submit-btn-rt" *ngIf="!mediaForm.get('title').invalid" matStepperNext>{{ "Next" | translate }}</button>
          <button class="submit-btnTop-rt" *ngIf="!mediaForm.get('title').invalid" (click)="saveMedia()">{{ "Save & close" | translate }}</button>
        </div>
      </mat-step>
      <mat-step *ngIf="showMediaStep">
        <ng-template matStepLabel>{{ "Media File" | translate }}</ng-template>
        <div class="row mt-5">
          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="fileType" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "File Type" | translate }} --</option>
                  <option *ngFor="let fileType of dropdownMediaData.mediaConfigDropDown?.fileType | sortAlpha : 'value'" [value]="fileType.value">
                    {{ fileType.value | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "File Type" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="resolution" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Resolution" | translate }} --</option>
                  <option *ngFor="let resolution of resolutionLabels" [value]="resolution">
                    {{ resolution | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Resolution" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="fileUrl" [attr.required]="true" />
                <label class="label-control">{{ "File Url" | translate }}</label>
                <small *ngIf="mediaForm.get('fileUrl')?.errors['required']">{{ "File Url is required" | translate }}</small>
                <small *ngIf="mediaForm.get('fileUrl')?.errors['pattern']">{{ "Please enter a valid URL or IP address." | translate }}</small>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="colorSpace" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Color Space" | translate }} --</option>
                  <option *ngFor="let colorSpace of dropdownMediaData.mediaConfigDropDown?.colorSpace | sortAlpha : 'value'" [value]="colorSpace.value">
                    {{ colorSpace.value | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Color Space" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="aspectRatio" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Aspect Ratio" | translate }} --</option>
                  <option *ngFor="let ratio of dropdownMediaData.mediaConfigDropDown?.aspectRatio | sortAlpha : 'value'" [value]="ratio.value">
                    {{ ratio.value | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Aspect Ratio" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="frameRate" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "FPS" | translate }} --</option>
                  <option *ngFor="let frame of dropdownMediaData.mediaConfigDropDown?.frameRate | sortAlpha : 'value'" [value]="frame.value">
                    {{ frame.value | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "FPS" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="audio" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Audio" | translate }} --</option>
                  <option *ngFor="let audio of dropdownMediaData.mediaConfigDropDown?.audio | sortAlpha : 'value'" [value]="audio.value">
                    {{ audio.value | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Audio" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-0 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="container" [attr.required]="true">
                  <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Container" | translate }} --</option>
                  <option *ngFor="let container of dropdownMediaData.mediaConfigDropDown.container | sortAlpha : 'value'" [value]="container.value">
                    {{ container.value | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Container" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group" style="margin-top: 30px">
              <div class="form-group w-100">
                <label class="label-control">{{ "Date" | translate }} : </label>
                <p-calendar [locale]="derivedSettings.customLocale" class="s-right" appendTo="body" placeholder="{{ 'Due Date' | translate }}" formControlName="date" [showTime]="true" [dateFormat]="derivedSettings.dateFormatCal" [hourFormat]="derivedSettings.timeFormat" [showIcon]="false">
                </p-calendar>
              </div>
            </div>
          </div>
          <div class="col-4" title="{{ thumbnailName ? thumbnailName : 'No file chosen' }}">
            <div class="relative">
              <div *ngIf="thumbnailUrl" class="upload-img">
                <input type="file" (change)="onThumbnailChange($event)" />
                <img [src]="thumbnailUrl" style="width: 100%; height: 100%" />
              </div>
              <div *ngIf="!thumbnailUrl" class="upload-img">
                <input type="file" (change)="onThumbnailChange($event)" />
                <i class="fa fa-file-image-o" aria-hidden="true"></i>
              </div>
            </div>

            <small class="smalltext"> Upload a thumbnail image. </small>

            <span *ngIf="thumbnailUrl" style="color: #27a465; text-align: left; font-size: 14px; margin-top: 5pt">
              <i *ngIf="thumbnailUrl" style="position: absolute; top: -6px; left: 66px; font-size: 12px; color: red; opacity: 1; cursor: pointer" class="fa fa-times-circle" (click)="removeThumbnail()"> </i>
            </span>

            <span *ngIf="invalidThumbnailFormatError" class="text-danger" style="text-align: left; font-size: 14px; margin-top: 5pt">
              {{ invalidThumbnailFormatError | translate }}
            </span>
          </div>
        </div>

        <div>
          <button class="submit-btn-lt" matStepperPrevious *ngIf="showMediaStep">{{ "Back" | translate }}</button>
          <button class="submit-btn-rt" matStepperNext>{{ "Next" | translate }}</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{ "Vault" | translate }}</ng-template>
        <div class="row mt-5">
          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="number" class="form-control modal-text-box" formControlName="vaultshelf" [attr.required]="true" />
                <label class="label-control">{{ "Shelf" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" formControlName="vaultstatus" [attr.required]="true">
                  <option value="Shipped">{{ "Shipped" | translate }}</option>
                  <option value="Received">{{ "Received" | translate }}</option>
                  <option value="MCR">{{ "MCR" | translate }}</option>
                  <option value="NA">{{ "NA" | translate }}</option>
                </select>
                <label class="label-control">{{ "Vault Status" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="number" class="form-control modal-text-box" formControlName="vaultsupport" [attr.required]="true" />
                <label class="label-control">{{ "Support" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="vaultmediaid" [attr.required]="true" />
                <label class="label-control">{{ "Media Id" | translate }}</label>
              </div>
            </div>
          </div>

          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <div class="form-group w-100">
                <select class="form-control modal-text-box" (change)="getBarCodeByType()" formControlName="barcode" [attr.required]="true">
                  <option *ngFor="let barcode of dropdownMediaData?.barcodeType" value="{{ barcode.id }}">
                    {{ barcode.barcodeType | translate }}
                  </option>
                </select>
                <label class="label-control">{{ "Barcode" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-4 mt-2 mb-5">
            <div class="input-group">
              <img *ngIf="barcodeUrl" [src]="barcodeUrl" class="img-fluid" width="110" height="110" />
            </div>
          </div>

          <div class="col-4 mt-2 mb-5" *ngIf="barcodeUrl">
            <div class="input-group">
              <div class="form-group w-100">
                <input type="text" class="form-control modal-text-box" formControlName="barcodeUId" [attr.required]="true" />
                <label class="label-control">{{ "Barcode UID" | translate }}</label>
              </div>
            </div>
          </div>
        </div>

        <div>
          <button class="delete-btn-lt" *ngIf="hideDelete" (click)="deleteMedia()"><i class="fas fa-trash-alt"></i>{{ "Delete" | translate }}</button>
          <button class="submit-btn-lt" matStepperPrevious *ngIf="showMediaStep">{{ "Back" | translate }}</button>

          <button class="submit-btnTop-rt" (click)="saveMedia()">{{ "Save & close" | translate }}</button>
        </div>
      </mat-step>
    </mat-stepper>
  </form>
</div>
